document.addEventListener('DOMContentLoaded', () => {
  const dropdownItems = document.querySelectorAll('.nav-desktop-li-dd-item');

  dropdownItems.forEach(item => {
    const btn   = item.querySelector('.nav-desktop-dd-btn');
    const panel = item.querySelector('.header-nav-desktop-dd-panel');
    const linksInsidePanel = panel ? panel.querySelectorAll('a') : [];

    if (!btn || !panel) return;

    let timeoutId = null;
    const delay = 150;

    const openPanel = () => {
      clearTimeout(timeoutId);
      panel.classList.add('dd-visible');
    };

    const closePanel = () => {
      timeoutId = setTimeout(() => {
        panel.classList.remove('dd-visible');
      }, delay);
    };

    btn.addEventListener('mouseenter', openPanel);
    panel.addEventListener('mouseenter', openPanel);
    btn.addEventListener('mouseleave', closePanel);
    panel.addEventListener('mouseleave', closePanel);

    linksInsidePanel.forEach(link => {
      link.addEventListener('click', () => {
        panel.classList.remove('dd-visible');
      });
    });

    btn.addEventListener('click', () => {
      const href = btn.getAttribute('href');
      if (href && href !== '#' && !href.startsWith('javascript:')) {
        setTimeout(() => panel.classList.remove('dd-visible'), 100);
      }
    });
  });

  const getHeaderHeight = () => {
    const header = document.querySelector('#shopify-section-header') ||
                   document.querySelector('header') ||
                   document.querySelector('.site-header') ||
                   document.querySelector('.header-wrapper');
    return header ? header.offsetHeight : 100;
  };

  const scrollToAnchor = (targetElement) => {
    if (!targetElement) return;

    const headerHeight = getHeaderHeight();
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = targetPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });

    document.querySelectorAll('.header-nav-desktop-dd-panel.dd-visible').forEach(p => {
      p.classList.remove('dd-visible');
    });
  };

  document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (!href || href.startsWith('javascript:')) return;

      let pathPart = '';
      let hashPart = '';

      const hashIndex = href.indexOf('#');
      if (hashIndex !== -1) {
        pathPart = href.substring(0, hashIndex);
        hashPart = href.substring(hashIndex + 1);
      } else {
        return;
      }

      if (!hashPart || hashPart === 'top') return;

      const targetElement = document.getElementById(hashPart);
      const currentPath = window.location.pathname;
      const normalizePath = (p) => p.replace(/\/$/, '') || '/';
      const isSamePage = pathPart === '' || normalizePath(pathPart) === normalizePath(currentPath);

      if (isSamePage && targetElement) {
        e.preventDefault();
        scrollToAnchor(targetElement);

        const newUrl = pathPart ? `${pathPart}#${hashPart}` : `#${hashPart}`;
        history.pushState(null, null, newUrl);
      }
    });
  });

  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash && hash !== 'top') {
      const targetElement = document.getElementById(hash);

      if (targetElement) {
        window.addEventListener('load', () => {
          setTimeout(() => {
            scrollToAnchor(targetElement);
          }, 100);
        });
      }
    }
  }
});